/**
 * PRD.330 Phase 2 — Query-driven pagination. Changes `query.page` only; the
 * rows for that page come back from the query layer (no local slicing).
 */
import { Button } from '@helios/ui';
import type { ReportPageInfo } from './report-view-logic';

export function ReportPagination({
  info,
  onPage,
}: {
  info: ReportPageInfo;
  onPage: (page: number) => void;
}) {
  return (
    <nav
      aria-label="Report pagination"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--sp-3)',
        fontSize: 'var(--font-size-sm)',
        color: 'var(--text-muted)',
      }}
    >
      <span>
        {info.totalCount === 0
          ? 'Showing 0 of 0'
          : `Showing ${info.firstRow}–${info.lastRow} of ${info.totalCount}`}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)' }}>
        <Button
          type="button"
          size="sm"
          variant="outline"
          aria-label="Previous page"
          disabled={!info.canPrev}
          onClick={() => onPage(info.page - 1)}
        >
          ‹ Prev
        </Button>
        <span aria-current="page">
          Page {info.page} of {info.pageCount}
        </span>
        <Button
          type="button"
          size="sm"
          variant="outline"
          aria-label="Next page"
          disabled={!info.canNext}
          onClick={() => onPage(info.page + 1)}
        >
          Next ›
        </Button>
      </div>
    </nav>
  );
}
